import { routeItem } from '@/types';
import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
const SettingsPage = lazy(() => import('./pages/SettingsPage'));

export const settingsRoutes: routeItem[] = [
  {
    path: 'settings',
    element: <Outlet />,
    permission:'roles.view',
    children: [
      {
        index: true,
        element: <SettingsPage />,
      },
    ],
  },
];